import React, { useEffect, useState } from "react";
import { motion } from "motion/react";

export function GuideTypingIndicator({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-2 rounded-2xl rounded-bl-md bg-white/80 border border-white/60 px-3.5 py-2.5 shadow-sm">
      <span className="text-[13px] text-gray-500">{label}</span>
      <span className="flex items-center gap-1 h-4">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="block w-1.5 h-1.5 rounded-full bg-indigo-400"
            animate={{ opacity: [0.25, 1, 0.25], y: [0, -2, 0] }}
            transition={{ duration: 0.9, repeat: Infinity, delay: i * 0.15 }}
          />
        ))}
      </span>
    </div>
  );
}

export function GuideAssistantText({
  text,
  animate,
  onComplete,
}: {
  text: string;
  animate?: boolean;
  onComplete?: () => void;
}) {
  const [shown, setShown] = useState(animate ? "" : text);

  useEffect(() => {
    if (!animate) {
      setShown(text);
      return;
    }
    setShown("");
    let i = 0;
    const chunk = Math.max(1, Math.ceil(text.length / 100));
    const timer = window.setInterval(() => {
      i += chunk;
      if (i >= text.length) {
        setShown(text);
        window.clearInterval(timer);
        onComplete?.();
      } else {
        setShown(text.slice(0, i));
      }
    }, 18);
    return () => window.clearInterval(timer);
  }, [text, animate, onComplete]);

  return <div className="whitespace-pre-wrap break-words">{shown}</div>;
}
